export enum HeaderMenuItem {
    GlobalStyle = 'globalStyle',
    Theme = 'theme',
    TemplateSelector = 'templateSelector'
}
